module.exports = __webpack_public_path__ + "static/img/weixin_qrcode.63e9ec1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weixin_qrcode.jpg
// module id = v+ev
// module chunks = 1